(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["glb-blog"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('glb-journal')) {
  customElements.define('glb-journal', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      const filters = this.querySelector('.glb-filters');
      const cards = [...this.querySelectorAll('[data-glb-grid] > .glb-card')];
      if (!filters) return;
      filters.hidden = false;
      filters.addEventListener('click', event => {
        const button = event.target.closest('[data-glb-filter]');
        if (!button) return;
        const topic = button.dataset.glbFilter;
        filters.querySelectorAll('button').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        let count = 0;
        cards.forEach(card => { card.hidden = topic !== 'all' && card.dataset.glbCategory !== topic; if (!card.hidden) count++; });
        this.querySelector('.glb-count').textContent = this.dataset.countTemplate.replace('__COUNT__', String(count));
        this.querySelector('.glb-empty').hidden = count > 0;
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
